import { CFormTextarea } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'

const GraytextareaAdjustable = ({ autoResize = true, disabled = false, style, showTreatmentAsAccordion, resizable = true, ...props }) => {
  const textareaRef = useRef(null)
  const [isManuallyResized, setIsManuallyResized] = useState(false)
  const startHeightRef = useRef(0)

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const handleAutoResize = () => {
    if (!autoResize || isManuallyResized || !textareaRef.current) return

    const el = textareaRef.current
    el.style.height = props?.height ? props.height : 'auto'
    el.style.height = `${el.scrollHeight}px`
  }

  useEffect(() => {
    handleAutoResize()
  }, [props.value, isManuallyResized])

  const handleMouseDown = () => {
    if (textareaRef.current) {
      startHeightRef.current = textareaRef.current.offsetHeight
    }
  }

  const handleMouseUp = () => {
    if (textareaRef.current) {
      if (textareaRef.current.offsetHeight !== startHeightRef.current) {
        setIsManuallyResized(true)
      }
    }
  }

  return (
    <CFormTextarea
      ref={textareaRef}
      disabled={disabled}
      onInput={handleAutoResize}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      style={{
        border: '1px solid rgb(113, 113, 113)',
        borderRadius: '8px',
        color: role === 'provider' ? 'var(--ui-text-primary, inherit)' : 'var(--ui-text-primary, inherit)',
        background: 'transparent',
        backgroundColor: 'transparent',
        fontSize: '14px',
        ...style,
        height: isManuallyResized ? undefined : (autoResize ? 'auto' : props.height),
        resize: resizable ? 'vertical' : 'none',
        overflow: isManuallyResized ? 'auto' : 'hidden',
      }}
      {...props}
    />
  )
}

export default GraytextareaAdjustable

